import { render } from "./SalesPageShell.vue?vue&type=template&id=1405a309"
import script from "./SalesPageShell.vue?vue&type=script&lang=js"
export * from "./SalesPageShell.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__